import { createFeatureSelector } from '@ngrx/store';
import { adminKey } from '../reducers/admin.reducers';
import { AdminState } from '../states/admin.states';

export const selectAdminState = createFeatureSelector<AdminState>(adminKey);

